import { useMemo } from 'react';

import { BidSheetRow } from '../../../hooks/useBidSheetState';

const getMinValue = (bid: BidSheetRow, name: 'volume' | 'bidPrice' | 'downPayment' | 'discount'): number => {
  const { steps } = bid[`${name}Config`];

  if (steps?.length === 2 || steps?.length === 4) {
    return steps[0];
  }

  return 0;
};

const useInitialValues = (bid: BidSheetRow): BidSheetRow =>
  useMemo(() => {
    if (bid.modified) {
      return bid;
    } else {
      return {
        ...bid,
        volume: getMinValue(bid, 'volume'),
        bidPrice: getMinValue(bid, 'bidPrice'),
        downPayment: getMinValue(bid, 'downPayment'),
        discount: getMinValue(bid, 'discount'),
      };
    }
  }, [bid]);

export default useInitialValues;
